module.exports = __webpack_public_path__ + "static/media/(LH)-Prata-04.6177c942.jpg";